import { z } from "zod";
export const rejectContentSchema = z.object({
    reason: z.string().min(1).max(500),
});
export const pauseContentSchema = z.object({
    password: z.string().min(1).max(128),
});
export const unpauseContentSchema = z.object({
    password: z.string().min(1).max(128),
});
export const resellerRollbackSchema = z.object({
    snapshotId: z.string().min(1),
    password: z.string().min(1).max(128),
});
/** Default retention for logos referenced by reseller branding snapshots (90 days). */
export const RESELLER_SNAPSHOT_RETENTION_MS = 90 * 24 * 60 * 60 * 1000;
//# sourceMappingURL=content-workflow.js.map